<div class="container-fluid">
  <h1>LDS HUB</h1>
  <hr>
  <p class="w-100">
    Welcome to LDS HUB.<br/>  
    To gain access to the application please proceed to the login page and verify your DaimlerID.<br/>
  </p>
  <p class="w-100 text-danger">System contains sensitive information!</p>    
</div>

